<template>
  <div class="LIST d-flex fd-column ov-y-scroll">
    <div
        v-for="item in list"
        :key="item.key"
        class="ITEM cur-pointer d-flex ai-center p-y-2 p-x-2 bd-b-gray30"
        :class="{ 'bg-gray30': item.key === selectedKey }"
        selenium="consumer-inbox-item"
        @click="$emit('select', item)">
      <avatar
          :name="item.name"
          :id="item.proUserId"
          :size="35"
          class="flex-0-0 m-r-2"
          selenium="message-avatar"/>
      <div class="flex-1-1 ov-hidden">
        <div class="d-flex jc-between">
          <span class="text-bold NAME">{{ item.name }}</span>
          <span class="flex-0-0 m-l-1 c-gray60 text-sm">{{ item.date }}</span>
        </div>
        <div class="d-flex jc-between ai-center">
          <span class="PREVIEW" :class="{ 'text-bold': item.unread }">{{ item.message }}</span>
          <span
              v-if="item.unread"
              class="NEW flex-0-0 m-l-1"
              selenium="consumer-inbox-new">New</span>
        </div>
      </div>
    </div>
    <div v-if="loading" class="d-flex jc-center p-2">
      <loading-indicator :size="24"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'conversation-list',
  props: {
    list: {
      type: Array,
      required: true,
    },
    selectedKey: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .LIST { height: 100%; }
  .ITEM:hover { background-color: $color-gray20; }
  .NAME, .PREVIEW {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .NEW {
    color: white;
    background-color: #286FAD;
    border-radius: 16px;
    padding: 0 8px;
  }
</style>
